module.exports = __webpack_public_path__ + "static/media/close_popup_home.8df69835.svg";